import React from 'react';

import cn from 'classnames';

import { IConDefaultType } from '..';

export enum SocialIconVariant {
  APPLE = 'apple',
  KAKAO = 'kakao',
  FACEBOOK = 'facebook',
  FACEBOOK_SIMPLE = 'facebook_simple',
  GOOGLE = 'google',
  DISCORD = 'discord',
  X = 'x',
  KAKAO_TOKEN = 'kakao_token',
}
interface ISocialIconProps extends IConDefaultType {
  variant?: SocialIconVariant;
}

export default function SocialIcon({
  color,
  className,
  size = 24,
  rotate,
  flip,
  variant = SocialIconVariant.APPLE,
  style,
  isDarkMode = false,
}: ISocialIconProps) {
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
        ...style,
      }}
    >
      {variant === SocialIconVariant.APPLE && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Property 1=apple">
            <g id="logo/apple">
              <path
                id="logo_apple"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M16.3991 1C16.3991 1 14.3822 1.00912 12.9315 2.87968C11.6414 4.54306 11.9698 5.96575 11.9698 5.96575C11.9698 5.96575 13.719 6.26175 15.2578 4.45279C16.6991 2.75865 16.3991 1 16.3991 1ZM13.3115 6.85692C12.8367 7.04413 12.4466 7.19796 12.1544 7.19796C11.7902 7.19796 11.3508 7.03237 10.8401 6.83993C10.1319 6.57304 9.28669 6.25452 8.315 6.25452C5.74257 6.25452 3 8.50781 3 12.8032C3 17.1691 6.24015 22.6004 8.80488 22.6003C9.20386 22.6003 9.69804 22.4251 10.2459 22.2308C10.9274 21.9892 11.692 21.7181 12.4598 21.7181C13.1483 21.7181 13.7454 21.9363 14.3346 22.1517C14.9087 22.3615 15.4754 22.5686 16.112 22.5686C18.9206 22.5686 21 16.843 21 16.843C21 16.843 18.0254 15.7163 18.0254 12.4471C18.0254 9.54905 20.4132 8.3547 20.4132 8.3547C20.4132 8.3547 19.1923 6.19434 16.0889 6.19434C14.9918 6.19434 14.0494 6.56595 13.3115 6.85692Z"
                fill="black"
              />
            </g>
          </g>
        </svg>
      )}
      {variant === SocialIconVariant.KAKAO && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Property 1=kakao">
            <g id="logo/kakao">
              <path
                id="logo/kakao_2"
                d="M11.9998 3.00039C6.47766 3.00039 2 6.5358 2 10.8995C2 13.7025 3.85458 16.1635 6.63972 17.5682L5.69748 21.0854C5.66142 21.1933 5.69133 21.3077 5.76959 21.3855C5.82348 21.4398 5.89539 21.4697 5.97345 21.4697C6.03368 21.4697 6.09351 21.4458 6.1476 21.4038L10.1991 18.6666C10.7875 18.7506 11.3878 18.7985 11.9998 18.7985C17.5219 18.7985 22 15.2633 22 10.8995C22 6.5358 17.5219 3.00039 11.9998 3.00039Z"
                fill="#3C1E1E"
              />
            </g>
          </g>
        </svg>
      )}
      {variant === SocialIconVariant.FACEBOOK && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Property 1=facebook">
            <g id="logo/facebook">
              <path
                id="logo_facebook 2"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 12.0611C22 6.50452 17.5229 2 12 2C6.47715 2 2 6.50452 2 12.0611C2 17.0829 5.65686 21.2453 10.4375 22V14.9694H7.89844V12.0611H10.4375V9.84454C10.4375 7.32297 11.9304 5.93013 14.2146 5.93013C15.3088 5.93013 16.4531 6.12664 16.4531 6.12664V8.60262H15.1921C13.9499 8.60262 13.5625 9.37817 13.5625 10.1738V12.0611H16.3359L15.8926 14.9694H13.5625V22C18.3431 21.2453 22 17.0829 22 12.0611Z"
                fill="#396CE9"
              />
            </g>
          </g>
        </svg>
      )}
      {variant === SocialIconVariant.GOOGLE && (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Property 1=google">
            <g id="logo/google">
              <mask
                id="mask0_1508_65835"
                style={{ maskType: 'luminance' }}
                maskUnits="userSpaceOnUse"
                x="2"
                y="2"
                width="20"
                height="20"
              >
                <path
                  id="Clip 2"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M2 12C2 17.5455 6.55814 22 12.2326 22C17.3488 22 22 18.3636 22 12C22 11.4091 21.907 10.7727 21.7674 10.1818H12.2326V14.0455H17.7209C17.2093 16.5 15.0698 17.9091 12.2326 17.9091C8.88372 17.9091 6.18605 15.2727 6.18605 12C6.18605 8.72727 8.88372 6.09091 12.2326 6.09091C13.6744 6.09091 14.9767 6.59091 16 7.40909L18.9767 4.5C17.1628 2.95455 14.8372 2 12.2326 2C6.55814 2 2 6.45455 2 12Z"
                  fill="white"
                />
              </mask>
              <g mask="url(#mask0_1508_65835)">
                <path
                  id="Fill 1"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.06958 17.9091V6.09091L8.97656 12L1.06958 17.9091Z"
                  fill="#FBBC05"
                />
                <path
                  id="Fill 4"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.06958 6.09091L8.97656 12L12.2324 9.22728L23.3952 7.45455V1.09091H1.06958V6.09091Z"
                  fill="#EA4335"
                />
                <path
                  id="Fill 7"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M1.06958 17.9091L15.0231 7.45455L18.6975 7.90909L23.3952 1.09091V22.9091H1.06958V17.9091Z"
                  fill="#34A853"
                />
                <path
                  id="Fill 10"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M23.3953 22.9091L8.97668 12L7.11621 10.6364L23.3953 6.09091V22.9091Z"
                  fill="#4285F4"
                />
              </g>
            </g>
          </g>
        </svg>
      )}
      {variant === SocialIconVariant.X && (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
          <path
            d="M12.6009 0H15.0544L9.69434 6.77744L16 16H11.0627L7.19566 10.4066L2.77087 16H0.31595L6.04904 8.75077L0 0H5.06262L8.55811 5.11262L12.6009 0ZM11.7399 14.3754H13.0993L4.32392 1.53928H2.86506L11.7399 14.3754Z"
            fill={isDarkMode ? 'white' : 'black'}
          />
        </svg>
      )}
      {variant === SocialIconVariant.DISCORD && (
        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
          <path
            d="M17.8829 1.33997C16.4959 0.70497 15.0317 0.254475 13.5276 0C13.3218 0.367934 13.1355 0.746489 12.9697 1.13408C11.3675 0.892656 9.73828 0.892656 8.13614 1.13408C7.97019 0.746529 7.78397 0.367978 7.57823 0C6.07319 0.256624 4.60798 0.708188 3.21958 1.3433C0.463247 5.42134 -0.283951 9.39809 0.0896478 13.3184C1.70382 14.511 3.51055 15.418 5.43128 16C5.86378 15.4183 6.24648 14.8012 6.57533 14.1553C5.95072 13.922 5.34787 13.6342 4.77375 13.2951C4.92485 13.1856 5.07263 13.0726 5.21543 12.9631C6.88599 13.7487 8.70933 14.156 10.5554 14.156C12.4015 14.156 14.2248 13.7487 15.8954 12.9631C16.0398 13.0809 16.1876 13.1939 16.3371 13.2951C15.7618 13.6347 15.1579 13.9231 14.5322 14.1569C14.8606 14.8026 15.2433 15.4192 15.6762 16C17.5986 15.4204 19.4067 14.5138 21.0212 13.32C21.4595 8.77377 20.2723 4.83354 17.8829 1.33997ZM7.04855 10.9074C6.00746 10.9074 5.14735 9.96264 5.14735 8.80033C5.14735 7.63802 5.97757 6.68493 7.04523 6.68493C8.11289 6.68493 8.96636 7.63802 8.9481 8.80033C8.92983 9.96264 8.10957 10.9074 7.04855 10.9074ZM14.0623 10.9074C13.0195 10.9074 12.1627 9.96264 12.1627 8.80033C12.1627 7.63802 12.9929 6.68493 14.0623 6.68493C15.1316 6.68493 15.9784 7.63802 15.9601 8.80033C15.9419 9.96264 15.1233 10.9074 14.0623 10.9074Z"
            fill="#5865F2"
          />
        </svg>
      )}
      {/* 내부 디자인 아이콘 (기존과 차이점 : 상하좌우 패딩 없음) */}
      {variant === SocialIconVariant.KAKAO_TOKEN &&
        (isDarkMode ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 18" fill="none">
            <path
              d="M10.0007 1C5.21448 1 1.33398 4.0624 1.33398 7.84312C1.33398 10.2717 2.94093 12.4035 5.35532 13.62L4.53848 16.6672C4.51274 16.7441 4.52554 16.8288 4.57288 16.8947C4.62023 16.9606 4.69636 16.9998 4.77754 17C4.83305 16.9985 4.88645 16.9784 4.92921 16.943L8.43921 14.5714C8.94982 14.6444 9.46982 14.6862 10.0007 14.6862C14.7861 14.6862 18.6673 11.6231 18.6673 7.84312C18.6673 4.0624 14.7861 1 10.0007 1Z"
              fill="#3C1E1E"
            />
            <path
              d="M10.0007 1C5.21448 1 1.33398 4.0624 1.33398 7.84312C1.33398 10.2717 2.94093 12.4035 5.35532 13.62L4.53848 16.6672C4.51274 16.7441 4.52554 16.8288 4.57288 16.8947C4.62023 16.9606 4.69636 16.9998 4.77754 17C4.83305 16.9985 4.88645 16.9784 4.92921 16.943L8.43921 14.5714C8.94982 14.6444 9.46982 14.6862 10.0007 14.6862C14.7861 14.6862 18.6673 11.6231 18.6673 7.84312C18.6673 4.0624 14.7861 1 10.0007 1"
              stroke="white"
            />
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="16" viewBox="0 0 18 16" fill="none">
            <path
              d="M9.00065 0C4.21448 0 0.333984 3.0624 0.333984 6.84312C0.333984 9.27167 1.94093 11.4035 4.35532 12.62L3.53848 15.6672C3.51274 15.7441 3.52554 15.8288 3.57288 15.8947C3.62023 15.9606 3.69636 15.9998 3.77754 16C3.83305 15.9985 3.88645 15.9784 3.92921 15.943L7.43921 13.5714C7.94982 13.6444 8.46982 13.6862 9.00065 13.6862C13.7861 13.6862 17.6673 10.6231 17.6673 6.84312C17.6673 3.0624 13.7861 0 9.00065 0Z"
              fill="#3C1E1E"
            />
          </svg>
        ))}
      {variant === SocialIconVariant.FACEBOOK_SIMPLE && (
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M13.8143 10.9702L14.269 7.97669H11.4251V6.03495C11.4251 5.21577 11.8216 4.41682 13.0954 4.41682H14.3891V1.86828C14.3891 1.86828 13.2155 1.66602 12.094 1.66602C9.75081 1.66602 8.22073 3.10008 8.22073 5.69514V7.97669H5.61719V10.9702H8.22073V18.2073C8.74344 18.2902 9.27817 18.3327 9.82291 18.3327C10.3676 18.3327 10.9024 18.2902 11.4251 18.2073V10.9702H13.8143Z"
            fill="#1877F2"
          />
        </svg>
      )}
    </i>
  );
}
